export interface IDataWrapper<T = any> {
    code: number
    msg: string
    data: T
}

/**
 * Yes: '1'
 * No: '0'
 * $t('enum.E_YesNo.Yes')
 * $t('enum.E_YesNo.No')
 */
export enum E_YesNo {
    Yes = '1',
    No = '0'
}

/**
 * Yes: 1
 * No: 0
 * 
 * $t('enum.E_YesNoNumber__OpenClose.Yes')
 * $t('enum.E_YesNoNumber__OpenClose.No')
 */
export enum E_YesNoNumber {
    Yes = 1,
    No = 0,
}

/**
 * Yes: 0
 * No: 1
 */
export enum E_YesNoInverse {
    Yes = 0,
    No = 1,
}

/**
 * Open: 1
 * Close: 2
 * $t('enum.E_OpenClose1_2.Close1')
 * $t('enum.E_OpenClose1_2.Open')
 * $t('enum.E_OpenClose1_2.Close')
 */
export enum E_OpenClose1_2 {
    Close1 = 0,
    Open = 1,
    Close =2,
}


export enum E_PageAsc {
    desc = 'desc',
    asc = 'asc',
}

export interface IPageOrderParams {
    /**
     * 排序的方向
     */
    isAsc?: E_PageAsc
    /**
     * 排序列
     */
    orderByColumn?: string
}

export type IPageParams = {
    pageNum: number
    pageSize: number
} & Partial<IPageOrderParams>

export interface IPageData<T> {
    current: number
    orders: any[]
    searchCount: boolean
    records: T[]
    size: number
    total: number
}

export interface IOptionNumberItem {
    value: number
    label: string
}

export interface IOptionStringItem {
    value: string
    label: string
}

export interface IOptionIdName {
    id: number
    name: string
}

/**
 * 坐标
 */
export interface ICoordinate {
    /**
    * 横坐标
    */
    abscissa: number
    /**
    * 纵坐标
    */
    ordinate: number
}

/**
 * $t('enum.E_Weekdays.Monday')
 * $t('enum.E_Weekdays.Tuesday')
 * $t('enum.E_Weekdays.Wednesday')
 * $t('enum.E_Weekdays.Thursday')
 * $t('enum.E_Weekdays.Friday')
 * $t('enum.E_Weekdays.Saturday')
 * $t('enum.E_Weekdays.Sunday')
 */
export enum E_Weekdays {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
    Sunday = 7,
}
